import type {
  DeckIntelligence,
  OpportunityIteration,
  OpportunityIterationTrigger,
} from '../types';
import { overallOpportunityScore } from './deckIntelligenceScores';
import { newId } from './id';

/** Snapshot the current scores after a fresh analysis lands. */
export function buildOpportunityIteration(
  trigger: OpportunityIterationTrigger,
  summary: string,
  intelligence: DeckIntelligence
): OpportunityIteration {
  const { score } = overallOpportunityScore(intelligence);
  return {
    id: newId(),
    createdAt: new Date().toISOString(),
    trigger,
    summary: summary.trim() || 'Analysis updated.',
    overallScore: Math.round(score * 10) / 10,
    sectionScores: intelligence.sectionScores,
  };
}
